import React from 'react';
import { Col, Nav, Row, Tab } from 'react-bootstrap';

import { useHasAccess } from '../../hooks/useHasAccess';
import { Event } from '../../interfaces';
import { ErrorBoundary, EventThumb, Permission, Spacer } from '../atoms';
import { StreetView } from '../street_view/streetView';
import { EventTagsWithAutosave } from './EventTags/EventTagsWithAutosave';
import { StyledTabsContainer } from './components';
import { EventDetails } from './EventDetails';
import { Geocode } from './Geocode';
import { useFleet } from '../../hooks';
import { FleetUUIDs } from '../../enums';

interface Props {
  event: Event;
}

export function EventSummary(props: Props) {
  const { event } = props;
  const fleet = useFleet();
  const hasAccess = useHasAccess();

  const getDefaultActiveKey = () => {
    // FIXME come up with a way of having these enumerated but not exported?
    // So that we're not leaking customer IDs in the codebase?
    if (fleet.uuid === FleetUUIDs.SacRTBusStopShelter) {
      // SacRT bus stop shelter
      return 'event-tag';
    }
    return 'event-street';
  };

  return (
    <StyledTabsContainer>
      <Tab.Container defaultActiveKey={getDefaultActiveKey()} mountOnEnter>
        <Row>
          <Col>
            <Nav variant="tabs" justify>
              <Nav.Item>
                <Nav.Link eventKey="event-street" data-accesskey="KeyJ">
                  Street view
                </Nav.Link>
              </Nav.Item>

              <Permission permission="events:read:tags">
                <Nav.Item>
                  <Nav.Link eventKey="event-tag" data-accesskey="KeyK">
                    Tags
                  </Nav.Link>
                </Nav.Item>
              </Permission>

              <Nav.Item>
                {/* semicolon as access key */}
                <Nav.Link eventKey="report-details" data-accesskey="Semicolon">
                  Report
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
        </Row>

        <Row>
          <Col>
            <Tab.Content>
              <Tab.Pane eventKey="event-street" title="Street view">
                <Tab.Content>
                  <ErrorBoundary>
                    <StreetView event={event} style={{ display: 'block' }} />
                    <Spacer half />

                    <Geocode event={event} />
                    <Spacer half />
                    <EventThumb
                      zoomableImage
                      className="hdn-event-modal__context-image smaller"
                      event={event}
                      isStandardImageStyle
                      drawMetadata={hasAccess}
                    />
                  </ErrorBoundary>
                </Tab.Content>
              </Tab.Pane>

              <Permission permission="events:read:tags">
                <Tab.Pane eventKey="event-tag" title="Tags">
                  <Tab.Content>
                    <ErrorBoundary>
                      <EventTagsWithAutosave event={event} />
                    </ErrorBoundary>
                  </Tab.Content>
                </Tab.Pane>
              </Permission>

              <Tab.Pane eventKey="report-details" title="Report">
                <Tab.Content>
                  <ErrorBoundary>
                    <EventDetails event={event} />
                  </ErrorBoundary>
                </Tab.Content>
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </StyledTabsContainer>
  );
}
